module.exports = __webpack_public_path__ + "img/dataswipertitle.33a31ecd.png";